import React, { Component } from 'react'
import Axios from 'axios'

import { handleCaptchaPair } from 'utils/captchaPair'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    captchaVerification = async val => {
      await Axios.post('https://api.friendlycaptcha.com/api/v1/siteverify', {
        solution: val,
        ... handleCaptchaPair()
      });
    }

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          captchaVerification={ this.captchaVerification }
        />
      )
    }
  }
  return WithHOC
}

export default HOC